Q             = require('q')
_             = require('underscore')
loaded        = false
googleMaps    = null
callbackQueue = []
scriptUrl     = "//maps.googleapis.com/maps/api/js"

util =

  mapsLoadCallback: ->
    loaded      = true
    googleMaps  = window.google.maps
    _.each callbackQueue, (deferred) -> deferred.resolve(googleMaps)

  scriptExists: ->
    document.getElementById('maps-script')? == true

  loadTag: (googleMapsKey) ->
    return if @scriptExists()

    url = "#{scriptUrl}?key=#{googleMapsKey}&callback=mapsLoadCallback"

    script        = document.createElement('script')
    script.id     = 'maps-script'
    script.type   = 'text/javascript'
    script.src    = url
    script.async  = true
    script.defer  = true
    script

    document.body.appendChild(script)

window.mapsLoadCallback = util.mapsLoadCallback

module.exports =
  namespaced: true

  state:

    defaultMapStyles: require('./default_map_styles')

  actions:

    load: (context) ->
      d = Q.defer()

      if loaded == true && googleMaps?
        d.resolve(googleMaps)
      else
        callbackQueue.push(d)
        if util.scriptExists != true
          util.loadTag(context.rootState.settings.google.maps_key)

      d.promise




// WEBPACK FOOTER //
// ./assets/js/frontend/store/google_maps/index.coffee